import qconsole from 'scripts/lib/qconsole';
import RelationshipLabel from 'scripts/domain/models/relationship_label';

export default class RelationshipLabelHttpGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  get store() {
    return this.context.stores.relationshipLabels;
  }

  handleAddLabel() {
    qconsole.log(`handleAddLabel`);
  }

  handleAddError(errorDto) {
    qconsole.log(`handleAddError ${errorDto}`);
  }

  handleFetchLabels(labelsDto) {
    this.store.resetLoading();
    this.store.set(labelsDto.map(l => RelationshipLabel.fromJs(l)));
  }

  handleFetchLabelsError(errorDto) {
    this.store.resetLoading();
    qconsole.log(`handleFetchLabelsError ${errorDto}`);
  }

  handleRemoveSuccess() {
    qconsole.log(`handleRemoveSuccess`);
  }

  handleRemoveError(errorDto) {
    qconsole.log(`handleRemoveError ${errorDto}`);
  }

  handleUpdateSuccess() {
    qconsole.log(`handleUpdateSuccess`);
  }

  handleUpdateError(errorDto) {
    qconsole.log(`handleUpdateError ${errorDto}`);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/relationship/relationship_label_gateway_observer.js